/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import { useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';
import styles from '../sass/style.module.scss';

export default function Modal({
  header,
  body,
  footer,
  show,
  onClose,
  justifyButtons = '',
  modalBodyCss = '',
  modalDialogCss = '',
  classNames,
  worldPaymentActive = false,
}) {
  const [open, setOpen] = useState(false);
  const [mobile, setMobile] = useState(window.innerWidth <= 500);

  useEffect(() => {
    // Prevent page scrolling while modal is open
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const handleWindowSizeChange = () => {
    setMobile(window.innerWidth <= 1025);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();

  useEffect(() => {
    setOpen(show);
  }, [show]);

  return (
    <>
      <div
        className={`${styles.modal} fade fixed top-0 left-0 ${
          open ? 'show' : 'hidden'
        } w-full h-full outline-none overflow-visible`}
        tabIndex="-1"
      >
        <div
          className={`${styles.modalDialog} ${styles.modalDialogCentered} ${styles.modalDialogScrollable} ${modalDialogCss} relative max-w-[1000px] lg:w-[50%] pointer-events-none`}
        >
          <div
            className={`${classNames} ${styles.modalContent} border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current`}
          >
            <div
              className={`${styles.modalHeader} flex flex-shrink-0 items-center justify-between pl-6 py-4 pr-4 border-b border-gray-200 rounded-t-md bg-slate-50`}
            >
              {worldPaymentActive ? (
                <div className="leading-[15px]">
                  <h5 className="text-[22px] font-medium text-gray-800">
                    Card Payment
                  </h5>
                  <small className="text-[12px] font-normal">
                    Do not refresh or close your browser window
                  </small>
                </div>
              ) : (
                <h5 className="text-[22px] font-medium leading-normal text-gray-800">
                  {header || ''}
                </h5>
              )}

              <div>
                <button
                  className="rounded-full p-0 h-[44px] w-[44px] flex items-center justify-center"
                  style={{
                    background: mobile
                      ? primaryColour || DEFAULT_PRIMARY_COLOUR
                      : '#FFF',
                    display: worldPaymentActive ? 'none' : 'flex',
                  }}
                  onClick={() => {
                    setOpen(false);
                    onClose();
                  }}
                  type="button"
                >
                  <MdClose fill={!mobile ? 'currentColor' : '#FFF'} />
                </button>
              </div>
            </div>
            <div className={`modal-body relative p-[25px] ${modalBodyCss}`}>
              {body || ''}
            </div>
            {footer && (
              <div
                className={`modal-footer flex flex-shrink-0 flex-wrap items-center pl-6 py-4 pr-4 border-t border-gray-200 rounded-b-md ${
                  justifyButtons !== '' ? justifyButtons : 'justify-between'
                }`}
              >
                {footer || ''}
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className={`${styles.modalBackdrop} fade ${open ? 'show' : 'hidden'}`}
      />
    </>
  );
}
